module.exports = __webpack_public_path__ + "img/stock6.5a9bbb2b.png";